
// RMKM Points
// added by jaseem  husaain
// date : 12 Sep 2025
// Asign question (Module) for IEP                 

import React, { useState, useEffect } from "react";
import { Modal, Button, Container, Row, Col, Table, Form, Spinner, ListGroup } from "react-bootstrap";
import PubSub from "pubsub-js";
import inventoryApi from "../api/inventoryApi";

const AssignQuestion = (props) => {
    const [questions, setQuestions] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [preSelectedIds, setPreSelectedIds] = useState([]);

    // Fetch questions
    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const result = await inventoryApi.fetchQuestions();
                if (result && Array.isArray(result)) {
                    const processed = result.map((q, idx) => ({
                        id: q.id,
                        text: q.question || "",
                        category: q.category || "",
                        section: q.section || "",
                        assessment: q.assessment || "",
                        index: idx + 1,
                    }));
                    setQuestions(processed);
                }
            } catch (err) {
                console.error("Failed to fetch questions", err);
            } finally {
                setLoading(false);
            }
        };
        fetchQuestions();
    }, [props?.preSelected]);

    // Sync selected questions when props.selectedQuestion changes
    useEffect(() => {
        if (questions?.length && props?.selectedQuestion?.length) {
            const result = props.selectedQuestion;
            const preSelectedIds = result.map((item) => item.questionid);
            setSelectedIds(preSelectedIds);
            setPreSelectedIds(preSelectedIds);
        }
    }, [questions, props?.selectedQuestion]);

    // Always keep selectedQuestions in sync with selectedIds
    useEffect(() => {
        setSelectedQuestions(questions.filter((q) => selectedIds.includes(q.id)));
    }, [selectedIds, questions]);

    //--
    const userRole = localStorage.getItem("userrole");
    const toggleSelect = async (id, questionText) => {
        // Pehle check karo already selected hai ya nahi
        const exists = selectedIds.includes(id);
        // UI turant update karo
        setSelectedIds((prev) =>
            exists ? prev.filter((x) => x !== id) : [...prev, id]
        );
         if (
           exists &&
           preSelectedIds.includes(id) &&
           userRole !== "SUPER_ADMIN"
         ) {
           PubSub.publish("RECORD_ERROR_TOAST", {
             title: "Not Allowed",
             message: "Only Super Admin can remove this question.",
           });
           return;
         }
        try {
            let result;

            if (exists) {
                //  Already selected → remove API call
                result = await inventoryApi.removeAssessmentQuestion(id);

                if(result?.success){
                    PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Succesfully",
                    message: `Question removed.`,
                });
                // props?.setRefershQuestionList();
                }else{
                    PubSub.publish("RECORD_ERROR_TOAST", {
                    title: "Failed",
                    message: "Question not remove",
                    });
                }
                
            } else {
                // Not selected → add API call
                result = await inventoryApi.addAssessmentQuestion({
                    questionid: id,
                    assessmentid: props?.parentId,
                });
                if(result?.success){
                    PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Selected",
                    message: `"${questionText?.slice(0, 60) || "Question"}" selected.`,
                });
                    // props?.setRefershQuestionList();
                }else{
                    PubSub.publish("RECORD_ERROR_TOAST", {
                    title: "Failed",
                    message: "Add failed",
                    });
                }
            }
        } catch (err) {
            console.error("API failed", err);
            setSelectedIds((prev) =>
                exists ? [...prev, id] : prev.filter((x) => x !== id)
            );
            PubSub.publish("RECORD_SAVED_TOAST", {
                title: "Error",
                message: `Something went wrong. Please try again.`,
            });
        }
    };

    const handleSelectAllVisible = () => {
        const visibleIds = filteredQuestions.map((q) => q.id);
        const allSelected = visibleIds.every((id) => selectedIds.includes(id));
        if (allSelected) {
            setSelectedIds((prev) => prev.filter((id) => !visibleIds.includes(id)));
        } else {
            setSelectedIds((prev) => Array.from(new Set([...prev, ...visibleIds])));
        }
    };

    const clearAll = () => {
        setSelectedIds([]);
        PubSub.publish("RECORD_SAVED_TOAST", {
            title: "Cleared",
            message: "All selected questions removed.",
        });
    };

    const filteredQuestions = questions.filter((q) => {
        if (!searchTerm) return true;
        const s = searchTerm.toLowerCase();
        return (
            (q.text || "").toLowerCase().includes(s) ||
            (q.category || "").toLowerCase().includes(s) ||
            (q.section || "").toLowerCase().includes(s) ||
            (q.assessment || "").toLowerCase().includes(s)
        );
    });

    return (
      <Modal {...props} size="lg" centered>
        <Modal.Header >
          <Modal.Title>Select Questions</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "68vh", overflowY: "auto" }}>
          <Container fluid>
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "200px" }}
              >
                <Spinner animation="border" role="status" />
                <span className="ms-2">Loading Questions...</span>
              </div>
            ) : (
              <Row>
                {/* LEFT: Question list */}
                <Col lg={8}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    {/* <Form.Control
                    type="text"
                    placeholder="Search Questions..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ maxWidth: "360px" }}
                  /> */}
                  </div>

                  <div style={{ overflowY: "auto" }}>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          {/* <th style={{ width: 50 }}>
                          <Form.Check
                            type="checkbox"
                            className="mb-3"
                            checked={
                              filteredQuestions.length > 0 &&
                              filteredQuestions.every((q) =>
                                selectedIds.includes(q.id)
                              )
                            }
                            onChange={handleSelectAllVisible}
                            aria-label="Select visible"
                          />
                        </th> */}
                          <th style={{ width: 50 }}>#</th>
                          <th>Question</th>
                        </tr>
                      </thead>

                      <tbody>
                        {filteredQuestions.length === 0 ? (
                          <tr>
                            <td colSpan={6} className="text-center">
                              No questions found.
                            </td>
                          </tr>
                        ) : (
                          filteredQuestions.map((q) => (
                            <tr key={q.id}>
                              <td className="align-middle ">
                                <Form.Check
                                  type="checkbox"
                                  checked={selectedIds.includes(q.id)}
                                  disabled={
                                    preSelectedIds.includes(q.id) &&
                                    localStorage.getItem("userrole") !==
                                      "SUPER_ADMIN"
                                  }
                                  onChange={() => toggleSelect(q.id, q.text)}
                                  aria-label={`Select question ${q.index}`}
                                />
                              </td>
                              <td className="align-middle">{q.text}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>

                {/* RIGHT: Selected */}
                <Col lg={4}>
                  <div style={{ maxHeight: "420px", overflowY: "auto" }}>
                    <ListGroup>
                      <ListGroup.Item
                        style={{ backgroundColor: "#1A293B", color: "white" }}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <b>Selected Questions ({selectedIds.length})</b>
                        {/* {selectedIds.length > 0 && (
                        <Button
                          variant="outline-light"
                          size="sm"
                          onClick={clearAll}
                        >
                          Clear All
                        </Button>
                      )} */}
                      </ListGroup.Item>

                      {selectedQuestions.length === 0 && (
                        <ListGroup.Item>No questions selected.</ListGroup.Item>
                      )}

                      {selectedQuestions.map((q) => (
                        <ListGroup.Item
                          key={q.id}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: 220,
                            }}
                          >
                            {q.text}
                          </div>
                          <div>
                            {localStorage.getItem("userrole") ===
                              "SUPER_ADMIN" && (
                              <Button
                                variant="link"
                                size="sm"
                                onClick={() => toggleSelect(q.id, q.text)}
                                style={{
                                  color: "#dc3545",
                                  textDecoration: "none",
                                }}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </Button>
                            )}
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                </Col>
              </Row>
            )}
          </Container>
        </Modal.Body>
        <Modal.Footer
          className="border-top"
          style={{
            position: "sticky",
            bottom: 0,
            background: "#fff",
            zIndex: 1,
          }}
        >
          {/* <Button
          variant="success"
          onClick={() => {props?.setRefershQuestionList(); props.onHide();}}
          disabled={selectedIds.length === 0}
        >
          Submit
        </Button> */}
          <Button
            variant="light"
            onClick={() => {
            props.onHide();
            props?.setRefershQuestionList();
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

export default AssignQuestion;






